import { ApiType } from "@gymflow/common";
import { PromotionDTO } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { promotionQueryKeys } from "./promotionQueryKeys";

export function usePromotion(
  {
    api,
    promotionId,
  }: {
    api: ApiType;
    promotionId?: number;
  },
  queryOpts?: Omit<UseQueryOptions<PromotionDTO | null>, "queryKey">,
) {
  return useQuery({
    queryKey: promotionQueryKeys.details(promotionId),
    queryFn: async () => {
      return (await api.promotionApi.findById(promotionId as number)).data;
    },
    enabled: !!promotionId,
    ...queryOpts,
  });
}
